import { Controller, type Control } from "react-hook-form";
import Checkbox from "@/components/Checkbox";
import type { CreateTestPersonFormValues } from "./types";

type EligibilitySectionProps = {
  control: Control<CreateTestPersonFormValues>;
  isStudent: boolean;
  isProspect: boolean;
};

export default function EligibilitySection({ control, isStudent, isProspect }: EligibilitySectionProps) {
  return (
    <div data-testid="create-test-person-eligibility-section">
      <div className="text-title-medium mb-4">Eligibility</div>
      <div className="flex flex-col gap-4">
        <Controller
          control={control}
          name="includeApprovedBackgroundCheck"
          render={({ field }) => (
            <Checkbox
              name="includeApprovedBackgroundCheck"
              label="Approved Background Check"
              checked={field.value}
              onChange={field.onChange}
            />
          )}
        />

        {isStudent && (
          <div>
            <Controller
              control={control}
              name="droppedPgmStudent"
              render={({ field }) => (
                <Checkbox
                  name="droppedPgmStudent"
                  label="Dropped PGM Student"
                  checked={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            <p className="mt-1 ml-9 text-body-small text-sys-brand-on-surface-variant">
              Provisions a terminated student program with dropped PGM student status, regardless of the Status
              selection above.
            </p>
          </div>
        )}

        {isProspect && (
          <div className="flex flex-col gap-3">
            <div className="text-label-large text-sys-brand-on-surface">Prospect bands</div>
            <p className="text-body-small text-sys-brand-on-surface-variant">
              PQ band is optional. Qualifier Eligible (QE) band follows F0 complete in PGM path — check F0 for QE, or
              leave it unchecked for PQ-only testing. Affiliate apply requires an active QE band. When both PQ and QE
              apply, PQ ends the day before QE starts.
            </p>
            <Controller
              control={control}
              name="includePreQualifierBand"
              render={({ field }) => (
                <Checkbox
                  name="includePreQualifierBand"
                  label="Pre-Qualifier (PQ) Band"
                  checked={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
}
